<template>
    <!-- Vista per reimpostare la password a seguito della richiesta di password perduta o dimenticata -->
    <!-- oppure per rimpostare la password in seguito alla scadenza -->
    <CustomOverlay :show="show_overlay" :text="'Caricamento, attendere...'">
      <b-container class="min-vh-100">
        <b-row class="min-vh-100 justify-content-md-center align-items-center">
          <b-col lg="5">
            <!-- Logo del customer -->
            <b-img class="mb-3" center fluid :src="customer_styles.img_logo"></b-img>
            <h4 class="text-center mt-2 mb-2" :style="customer_styles.subtitle_text">
              <span v-if="is_expired_mode">Aggiornamento Password Scaduta</span>
              <span v-else>Reset Password Perduta</span>
            </h4>

            <!-- TOKEN ESISTENTE - SI VEDE IL FORM DI IMMISSIONE PASSWORD -->
            <div v-if="show_form">
              <!-- Testo informativo -->
              <b-row align-h="center" class="text-justify mt-3">
                <b-col :style="customer_styles.info_text">
                  <h6>Ricorda che la password:</h6>
                  <ul>
                    <li>deve avere una lunghezza compresa tra un minimo di 8 e un massimo di 32 caratteri.</li>
                    <li>deve contenere almeno un carattere maiuscolo, uno minuscolo e un numero.</li>
                    <li>non deve essere già stata utilizzata in passato.</li>
                  </ul>
                </b-col>
              </b-row>
              <!-- Form insermento nuova password -->
              <b-form @submit.prevent="password_update"
                      :style="customer_styles.form_body"
                      class="p-4">

                <FormNuovaPassword @dataChanged="new_passwd_form_change"/>

                <!-- La parte dell'otp viene visualizzata solo se l'utente usa tale metodo di autenticazione -->
                <!-- altimenti viene chiesto l'inserimento del codice fiscale -->
                <!-- OTP SE 2FA -->
                <b-form-group
                  v-if="is_2fa_otp"
                  id="otp-group"
                  label="Inserisci il codice OTP di sicurezza:"
                  label-for="otp"
                >
                  <b-input-group>
                    <b-input-group-prepend class="pr-1">
                      <b-icon icon="shield-lock" font-scale="2"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      id="otp"
                      v-model="form.otp"
                      type="text"
                      :state="form_state.otp_state"
                      placeholder="Scrivi il codice di sicurezza mostrato in app"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <!-- COD-FISCALE SE OTP VIA MAIL -->
                <b-form-group
                  v-else
                  id="cod-fisc-group"
                  label="Inserisci il tuo codice fiscale:"
                  label-for="cod-fisc"
                  invalidFeedback="Verifica che siano presenti tutti i 16 caratteri e che non vi siano spazi"
                  :state="form_state.cod_fisc_state"
                >
                  <b-input-group>
                    <b-input-group-prepend class="pr-1">
                      <b-icon icon="check2" font-scale="2"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      id="cod-fisc"
                      v-model="form.cod_fisc"
                      type="text"
                      :state="form_state.cod_fisc_state"
                      placeholder="Codice fiscale"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-row align-h="center">
                  <b-col cols="4" class="text-center">
                    <b-button id="submit_button" type="submit"
                              :disabled="submit_button_disabled"
                              :style="customer_styles.send_button">Invia</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>


            <!-- TOKEN NON ESISTENTE - SI VEDE SOLO UN MESSAGGIO INFORMATIVO DI ERRORE -->
            <div v-if="!show_form" class="mt-5" :style="customer_styles.info_text">
              <h4 class="text-center">
                <b-icon icon="exclamation-triangle"></b-icon> Si è verificato un errore
              </h4>
              <h5 v-if="!show_form" class="text-justify">
                {{error_message}}
              </h5>
              <br/>
              <p>Prima di provare nuovamente verifica i seguenti punti:</p>
              <ul class="text-justify">
                <li>Se hai copiato ed incollato il link verifica che esso sia corretto</li>
                <li>Controlla di non stare utilizzando il link riportato su di una vecchia mail di recupero password richiesta in passato</li>
              </ul>
              <p class="text-justify">Se continui a riscontrare problemi contatta la nostra assistenza</p>
            </div>

          </b-col>
        </b-row>
      </b-container>
    </CustomOverlay>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import FormNuovaPassword from '@/components/FormNuovaPassword'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'


export default {
  name: 'PasswordReset',
  mixins: [ customerStylesMixin ],
  data () {
    return {
      // Overlay di attesa
      show_overlay : false,

      // Flag che visualizza il form se l'hash del token è corretto
      // altrimenti viene nascosto
      show_form : true,

      // Metodo di autenticazione usato
      auth_method : null,

      // Messaggio di errore visualizzato se il token non è presente
      error_message : '',

      // Dati dal form della password ( nuova password, campo di conferma + OTP o codice fiscale a seconda dei casi )
      form : {
        new_passwd: null,
        passwd_confirm: null,
        otp: null,
        cod_fisc: null
      },

      // Stato dei campi dal form della password ( false per ko o null per ok )
      form_state : {
        new_passwd: null,
        passwd_confirm: null,
        otp_state : null,
        cod_fisc_state : null
      },

    }
  },
  computed : {
    /**
     * In base allo state dei due campi del form della nuvoa password abilita/disabilita il pulsante di invio
     */
    submit_button_disabled : function () {
      if ( this.form_state.new_passwd === null && this.form_state.passwd_confirm === null ){
        return false;
      }else{
        return true;
      }
    },
    /**
     * Restituisce un flag che ci dice se il form sta agendo in modalità password scaduta
     */
    is_expired_mode : function () {
      return this.form_mode === 'expired';
    },
    /**
     * Ci dice se l'utente sta usando l'autenticatore per l'accesso
     */
    is_2fa_otp : function () {
      return this.auth_method === '2fa' ? true : false;
    }
  },
  methods : {
    /**
     * Assegna dati in arrivo dal componente FormNuovaPassword alle corrispondenti
     * variabili di questa vista
     */
    new_passwd_form_change : function (data) {
      this.form.new_passwd = data.new_passwd;
      this.form.passwd_confirm = data.passwd_confirm;
      this.form_state.new_passwd = data.new_passwd_state;
      this.form_state.passwd_confirm = data.passwd_confirm_state;
    },
    /**
     * Al submit del form richiama la giusta funzione per il reset/aggiornamento della password
     * in base alla modalità di funzionamento del form.
     */
    password_update : function() {

      let api_call = apiUrl.userapi.password_lost_reset.replace( '@token_hash', this.token_hash );
      if ( this.is_expired_mode ) {
        api_call = apiUrl.userapi.password_expired_reset.replace( '@token_hash', this.token_hash );
      }

      // Se l'utente usa l'autenticazione 2fa dobbiamo controllare che sia presente il codice
      // ed eliminare dai dati inviare la mail, se invece usa l'autenticazione via mail dobbiamo
      // controllare che sia presente il codice fiscale e eliminare l'otp dai dati da inviare.
      if ( this.is_2fa_otp ) {
        if ( this.form.otp === null || this.form.otp === '' ) {
          this.form_state.otp_state = false;
          return;
        }
        // Resetto lo stato della casella se è ok
        this.form_state.otp_state = null;
        delete this.form.cod_fisc;
      } else {
        if ( this.form.cod_fisc === null || this.form.cod_fisc.length !== 16 ) {
          this.form_state.cod_fisc_state = false;
          return;
        }
        // Resetto lo stato della casella se è ok
        this.form_state.cod_fisc_state = null;
        delete this.form.otp;
      }

      this.show_overlay = true;

      axios.post( api_call, this.form )
      .then( ( response ) => {

        // Se la password non ha data di scadenza questa porzione del messaggio non la visualizziamo
        let scad_message = '';
        if ( response.data.pass_expiry_date != null ) {
          scad_message = " La tua nuova password scadrà il " + response.data.pass_expiry_date + ".";
        }
        let message = "Operazione completata con successo, premendo ok sarai riportato alla pagina di login. " +
                      "Ricorda di utilizzare la tua mail e la nuova password appena inserita per accedere." +
                      scad_message;

        this.new_password_state = true;
        this.show_overlay = false;

        this.$bvModal.msgBoxOk( message, {
          title: 'Operazione completata',
          centered: true
        })
        .then(value => {
          // Andiamo al login appartenente al customer settato.
          this.$router.push( { 'name' : 'login', params: { customer: this.$store.state.customer } } );
        });

      })
      .catch( ( error ) => {
        this.show_overlay = false;

        this.new_password_state = false;

        // Errore nella password immessa
        generalLib.backend_error_message_box( this, error.response.data );
      });

    }
  },
  /**
   * Al create verifichiamo subito se l'hash passato è valido, solo in quel caso
   * visualizziamo il form di cambio password che altrimenti rimane nascosto ed al
   * suo posto visualizziamo il messaggio di sistema.
   * Questa chiamata ci dice anche se l'utente usa l'autenticatore ( e qunidi dovremo
   * confermare il reset con l'OTP ) oppure se l'utente usa l'otp via mail e quindi
   * non dobbiamo chiedere l'OTP per il reset.
   */
  created : function () {
    this.show_overlay = true;

    let api_call = apiUrl.userapi.password_lost_reset.replace( '@token_hash', this.token_hash );
    if ( this.is_expired_mode ) {
      api_call = apiUrl.userapi.password_expired_reset.replace( '@token_hash', this.token_hash );
    }

    axios.get( api_call )
    .then( ( response ) => {
      // Se abbiamo la 20_OK il token esiste, possiamo visualizzare il form di
      // cambio password e valorizzare la variabile che ci dice il metodo di
      // autenticazione
      this.show_form = true;
      this.show_overlay = false;
      this.auth_method = response.data.auth_method;
    })
    .catch( ( error ) => {
      // Altrimenti il token non esiste, non visualizziamo il form ma il motivo del problema.
      this.show_form = false;
      this.error_message = error.response.data;
      this.show_overlay = false;
    });

  },
  props : {
    /**
     * Si tratta del codice hash del token che deve essere passato a questa vista dal
     * router per poter verificare se l'utente è abilitato o meno a poter resettare la
     * sua password.
     */
    token_hash: {
      type: String,
      required: true
    },
    /**
     * Una prop che indica alla vista se si tratta di resettare una password
     * perduta oppure ripristinare una password scaduta.
     */
    form_mode: {
      type: String,
      required: true,
      validator( value, props ) {
        // Uniche due stringhe valide per settare la modalità
        return ['lost', 'expired'].includes(value);
      }
    }
  },
  components: {
    CustomOverlay,
    FormNuovaPassword
  }
}
</script>

<style scope></style>
